import { css } from 'styled-components';

interface IMenuContainer {
  show?: boolean;
  control?: boolean;
}

const MenuContainer = css`
`;

export default MenuContainer;
